<ng-container *ngIf="label">
  <div class="mb-2">
    <app-input-label
      [label]="label"
      [isRequired]="isRequired"
      [noteText]="noteText"
    ></app-input-label>
  </div>
</ng-container>

<div>
  <ng-select
    [appendTo]="appendTo"
    dropdownPosition="auto"
    loadingText="Fetching results..."
    [loading]="isLoading"
    class="dropdown-input pb-0"
    [ngClass]="{
      'no-control-value': !control.value,
      'search-dropdown': searchFn,
      'control-value-invalid': control.touched && control.invalid
    }"
    [placeholder]="placeholder"
    [clearable]="false"
    [clearSearchOnAdd]="true"
    [virtualScroll]="true"
    [selectOnTab]="true"
    [closeOnSelect]="true"
    [multiple]="multiple"
    [searchable]="true"
    [readonly]="control.disabled"
    [searchFn]="searchFn"
    [bindLabel]="bindLabel"
    [bindValue]="bindValue"
    [items]="list"
    [formControl]="control"
    [markFirst]="markFirst"
    (change)="onValueSelect.emit($event)"
    (search)="onSearchChange($event)"
    (close)="ngSelect.blur()"
    (keydown.enter)="onEnterClickEvent($event)"
    #ngSelect
    [hideSelected]="customSelectedOption"
  >
    <ng-container *ngIf="customSelectedOption">
      <ng-template ng-label-tmp let-item="item">
        <div
          (mousedown)="$event.stopPropagation()"
          class="selected-item d-flex justify-content-center align-items-center"
        >
          {{ item[bindLabel] }}
          <img
            class="mx-2 remove-item cursor-pointer"
            (click)="OnRemoveItem.emit(item)"
            width="10"
            height="10"
            src="images/close.svg"
            alt="Close"
          />
        </div>
      </ng-template>

      <ng-template ng-option-tmp let-item="item">
        {{ item[bindLabel] }}
      </ng-template>
    </ng-container>

    <ng-template
      ng-option-tmp
      ng-label-tmp
      let-item="item"
      #dropdownOptionWithIcon
    >
      <div class="d-flex gap-3 align-items-center">
        <img
          *ngIf="isOptionWithIcon && item[bindImageKey]"
          [src]="item[bindImageKey]"
          width="24"
          height="24"
          alt=""
        />
        <div
          class="d-flex gap-3 justify-content-between flex-grow-1 align-items-center"
        >
          <b class="fw-500">{{ item[bindLabel] }}</b>

          <ng-container *ngIf="chipKey && item[chipKey]">
            <span class="tag-chip tag-chip-warning">
              {{ item[chipKey] || "-" }}
            </span>
          </ng-container>
        </div>
      </div>
    </ng-template>
  </ng-select>
</div>

<ng-container *ngIf="control.touched && isRequired">
  <p
    class="text-xs text-danger mt-1 mb-0"
    [label]="label"
    [dynamicErrorMsg]="control"
  ></p>
</ng-container>
